import styled from "@emotion/styled";
import PropTypes from "prop-types";
import React from "react";

import ButtonGroup from "~/components/layout/ButtonGroup";

import ActionButton from "~/components/links/ActionButton";

import { buttonColorOrderGrayBackground } from "~/constants/buttons";

const Actions = styled(ButtonGroup)`
    margin: ${({ theme, noMarginBottom }) =>
        noMarginBottom
            ? `${theme.layout.paragraphSpacing} 0 0 0`
            : `${theme.layout.paragraphSpacing} 0`};
`;

const HeaderLinkGroup = ({
    lang,
    links,
    noMarginBottom = false,
    colorOrder = buttonColorOrderGrayBackground,
    onLinkClick = () => {},
    slideIndex = 0,
    title = "",
}) => (
    <Actions {...{ noMarginBottom }}>
        {links.map(
            (
                {
                    action,
                    linkLabel,
                    linkUrl,
                    isEmbed,
                    videoType,
                    downloadVideo,
                    video,
                    videoUrl,
                    formId,
                },
                index,
            ) => (
                <ActionButton
                    lang={lang}
                    key={index}
                    color={colorOrder[index]}
                    onClick={onLinkClick}
                    {...{
                        action,
                        linkLabel,
                        linkUrl,
                        isEmbed,
                        videoType,
                        downloadVideo,
                        video,
                        videoUrl,
                        formId,
                        slideIndex,
                        title,
                    }}
                />
            ),
        )}
    </Actions>
);

HeaderLinkGroup.propTypes = {
    links: PropTypes.arrayOf(
        PropTypes.shape({
            action: PropTypes.oneOf(["link", "video", "form"]).isRequired,
            linkLabel: PropTypes.oneOfType([
                PropTypes.string,
                PropTypes.element,
            ]).isRequired,
            linkUrl: PropTypes.string,
            videoType: PropTypes.oneOf(["media", "download"]),
            downloadVideo: PropTypes.shape({}),
            video: PropTypes.shape({
                posterURL: PropTypes.string,
                mediaItemUrl: PropTypes.string,
            }),
            videoUrl: PropTypes.string,
            formId: PropTypes.number,
        }),
    ).isRequired,
    noMarginBottom: PropTypes.bool,
    colorOrder: PropTypes.arrayOf(PropTypes.string),
    onLinkClick: PropTypes.func,
    slideIndex: PropTypes.number,
    title: PropTypes.string,
};

export default HeaderLinkGroup;
